import React from "react";
import styles from "./styles/OutputWindow.module.css";

/**
 * Output window component
 * The back ground color will be set to the color provided, otherwise it will use the default css
 */
const OutputWindow = ({
    color,
    content,
    padding,
    fullWidth,
    background,
    blank,
    inheritCorner,
    stretch,
    minHeight,
    alignTop,
}) => {
    return (
        <div
            className={`${styles.main_output_container} ${
                alignTop ? styles.align_top : ""
            } ${fullWidth ? styles.fullWidth : ""}  ${
                stretch ? styles.stretch : ""
            }  flex-container`}
            style={{
                backgroundColor: color && `${color}${blank ? "" : "1A"}`,
                padding: padding ? padding : 0,
                borderRadius: inheritCorner ? "inherit" : null,
                minHeight: minHeight ? minHeight : null,
            }}
        >
            {content}

            {background ? (
                <div
                    className={`${styles.background}`}
                    style={{
                        backgroundColor: color && `${color}1A`,
                    }}
                ></div>
            ) : (
                <></>
            )}
        </div>
    );
};

export default OutputWindow;
